import { get } from './helpers'
import { PlannerWorkoutsResponse } from './types'

export const getPlannerWorkouts = async (start?: string, end?: string): Promise<PlannerWorkoutsResponse> => {
  const response = await get<PlannerWorkoutsResponse>(`planner?${start ? `start=${start}` : ''}${end ? `&end=${end}` : ''}`)

  return response
}
